<template>
  <div>
    <el-button
      type="primary"
      size="mini"
      style="margin-bottom: 20px"
      @click="hanlerAdd"
      >添加专家</el-button
    >
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      height="500px"
      v-loading="loading"
      :header-cell-style="{ background: '#f8f8f8' }"
    >
      <el-table-column
        type="index"
        width="70"
        label="序号"
        align="center"
        :index="indexMethod"
      >
      </el-table-column>
      <el-table-column prop="name" label="姓名" align="center" />
      <el-table-column prop="unit" label="单位" align="center" />
      <el-table-column
        prop="direction"
        label="研究方向"
        align="center"
        width="200"
        show-overflow-tooltip
      />
      <el-table-column prop="phone" label="手机号" align="center" />
      <el-table-column prop="email" label="邮箱" align="center" />
      <el-table-column prop="content" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="hanlerEdit(scope.row)">修改</el-button>
          <el-button type="text" @click="hanlerDelete(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div ref="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="searchForm.page"
        :limit.sync="searchForm.pagesize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      :before-close="cancel"
      :title="title"
      :visible.sync="dialogFormVisible"
      width="35%"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="姓名：" :label-width="formLabelWidth" prop="name">
          <el-autocomplete
            v-model="form.name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请填写"
            @select="handleSelect"
            :debounce="500"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="单位：" :label-width="formLabelWidth" prop="unit">
          <el-input v-model="form.unit" placeholder="请填写"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号："
          :label-width="formLabelWidth"
          prop="phone"
        >
          <el-input
            v-model="form.phone"
            placeholder="请填写"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" :label-width="formLabelWidth" prop="email">
          <el-input v-model="form.email" placeholder="请填写"></el-input>
        </el-form-item>
        <el-form-item
          label="研究方向："
          :label-width="formLabelWidth"
          prop="direction"
        >
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model="form.direction"
            maxlength="50"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">上 报</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectByName,
  addExpert,
  getExpertList,
  delExpert,
  editExpert,
} from "@/api/api.js";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      searchForm: {
        page: 1,
        pagesize: 20,
      },
      title: "",
      total: 1,
      dialogFormVisible: false,
      formLabelWidth: "82px",
      form: {
        name: "",
        unit: "",
        phone: "",
        direction: "",
        email: "",
        id: "",
      },
      rules: {
        phone: [
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.pagesize + index + 1;
    },
    getList() {
      this.loading = true;
      getExpertList(this.searchForm).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          let { total, list } = res.data.data;
          this.total = parseInt(total);
          this.tableData = list;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    submit() {
      if ((this.title = "专家信息")) {
        addExpert(this.form).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("添加成功");
            this.getList();
            this.cancel();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        editExpert(this.form).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("修改成功");
            this.getList();
            this.cancel();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    hanlerAdd() {
      this.dialogFormVisible = true;
      this.title = "专家信息";
    },
    hanlerEdit(row) {
      this.dialogFormVisible = true;
      this.title = "修改信息";
      this.form = {
        name: row.name,
        email: row.email,
        phone: row.phone,
        direction: row.direction,
        id: row.id,
        unit: row.unit,
      };
    },
    hanlerDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delExpert({ id }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },
    querySearchAsync(queryString, callback) {
      var result = [];
      var params = {
        name: queryString,
      };
      if (queryString == "") {
        callback(result);
      } else {
        selectByName(params).then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            res.data.data.forEach((item) => {
              result.push({
                id: item.id,
                value: item.name,
              });
            });

            callback(result);
          }
        });
      }
    },

    handleSelect(item) {
      this.form.id = item.id;
    },
    cancel() {
      this.reset();
      this.dialogFormVisible = false;
    },
    reset() {
      this.form = {
        name: "",
        email: "",
        phone: "",
        direction: "",
        id: "",
        unit: "",
      };
    },
  },
};
</script>

<style scoped>
::v-deep .pagination-container .el-pagination {
  right: 10px;
  position: absolute;
  bottom: 10px;
}
.el-input {
  width: auto !important;
}
</style>
